import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import "leaflet/dist/leaflet.css";
import "./styles.css";
import { ApiError } from "./lib/api.ts";
import { SESSION_ERRORS } from "./lib/session.tsx";
import { makeRouter } from "./router.tsx";
import { ThemeProvider } from "./lib/theme.tsx";
import { initErrorReporting } from "./lib/errors.ts";

initErrorReporting();

const queryClient: QueryClient = new QueryClient({
  defaultOptions: { queries: { retry: (n, e) => !(e instanceof ApiError) && n < 2, refetchOnWindowFocus: false } },
  // A session that expires or loses 2FA mid-use goes back through sign-in.
  queryCache: new QueryCache({
    onError: (e) => {
      if (e instanceof ApiError && SESSION_ERRORS.has(e.code)) {
        queryClient.removeQueries({ queryKey: ["session"] });
        void router.navigate({ to: e.code.startsWith("two_factor") ? "/entrar/verificar" : "/entrar", search: { erro: e.status === 401 ? undefined : e.code } as never });
      }
    },
  }),
});
const router = makeRouter(queryClient);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
